import { RootState } from "@/redux/store"
import { useGetQualityCheckUpdates } from "@/services"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"

const useChecksNoteDialog = () => {
  const {id} = useParams();
  const { taskData, checksData } = useSelector((state: RootState) => state.currentData)

  const {data: attachmentList, isLoading: isAttachmentsLoading} = useGetQualityCheckUpdates({
    taskId: taskData?.taskId,
    projectId: id as string,
    checkId: checksData?.taskQualityCheckId,
    queryParams: {
      enabled: !!checksData?.taskQualityCheckId
    }
  })

  const title = useMemo(() => {
    return `${checksData?.name} - Notes` || ''
  }, [checksData])

  return {
    isAttachmentsLoading,
    attachmentList,
    title
  }
}

export default useChecksNoteDialog;